<template>
  <div :class="$style['m-topBar']">
    <div :class="$style.banner">
      <img src="./assets/docs_logo.svg" :class="$style.logo" />
      <span :class="$style.title">{{ $t("d1a3a7b120") }}</span>
    </div>
    <div :class="$style.menu" v-if="fileInfo">
      <TopBarMenuMobile style="z-index: 2" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { TopBarMenuMobile } from '@/components/TopBarMenu'
export default {
  name: 'TopBar',
  components: {
    TopBarMenuMobile
  },
  computed: mapState(['fileType', 'fileInfo'])
}
</script>
<style lang="scss" module>
.m-topBar {
  height: 40px;
  border-bottom: 1px solid #dadada;
  box-sizing: border-box;
  background: #fff;
  display: flex;

  .banner {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }

  .logo {
    width: 24px;
    height: 28px;
    margin: 0 10px 0 7px;
  }

  .title {
    font-size: 14px;
    color: #666;
    font-weight: bolder;
  }

  .menu {
    display: flex;
    align-items: center;
  }
}
</style>
